import Navbar from './sections/navbar/Navbar';
import Header from './sections/header/Header';
import About from './sections/about/About';
import Skills from './sections/skills/Skills'; 
import Portfolio from './sections/portfolio/Portfolio';
import Contact from './sections/contact/Contact';
import Footer from './sections/footer/Footer';
import FloatingNav from './sections/floating-nav/FloatingNav';
import CustomCursor from './custom-cursor/CustomCursor';
import Modal from './components/Modal';
import Theme from './theme/Theme';
import { useThemeContext } from './context/theme-context';
import {useRef, useState, useEffect, useCallback } from 'react';

const App = () => {
  const {themeState} = useThemeContext();

  const mainRef = useRef(); 
  const [showFloatingNav, setShowFloatingNav] = useState(true);
  const [siteYPosition, setSiteYPosition] = useState(0);


  const showFloatingNavHandler = () => {
    setShowFloatingNav(true);
  }

  const hideFloatingNavHandler = () => {
    setShowFloatingNav(false);
  }

  // check if the floating nav should be shown or hidden
  const floatingNavToggleHandler = useCallback(() => {
    if(siteYPosition < (mainRef?.current?.getBoundingClientRect().y - 10) || siteYPosition > (mainRef?.current?.getBoundingClientRect().y + 10)) {
      showFloatingNavHandler();
    } else {
      hideFloatingNavHandler();
    }

    setSiteYPosition(mainRef?.current?.getBoundingClientRect().y);
  }, [siteYPosition]);

  useEffect(() => {
    const checkYPosition = setInterval(floatingNavToggleHandler, 2000);
    // cleanup
    return () => clearInterval(checkYPosition);
  }, [siteYPosition, floatingNavToggleHandler]);
  
  return (
    <main className={`${themeState.primary} ${themeState.background}`} ref={mainRef}>
      <Navbar/>   
      <Header/>
      <About/>
      <Skills/> 
      <Portfolio/>
      <Contact/>
      <Footer/>
      <Modal/>
      <Theme/>
      {showFloatingNav && <FloatingNav/>}
      <CustomCursor/>
    </main>
  )
}

export default App